import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import omitBy from 'lodash/omitBy';
import isNil from 'lodash/isNil';
import { PRODUCT_ADDON_TYPES, SINGLE_ADDON_TYPES, findVariantById } from 'src/common/utils/addons';
import { skus } from 'src/common/config/product';
import { trackAddOnsDeselected, trackAddOnsSelected } from '../../../analytics/category/product';

export const byAddonType = type => component => component.id.includes(type);
export const byAddonId = id => component => component.id === id;

export const updateComponents = (selectedAddons, addOn) => {
  const components = selectedAddons;
  if (addOn) {
    if (!!components.find(byAddonId(addOn.id))) {
      // If the id already exists
      const component = components.find(byAddonId(addOn.id));
      const idx = components.indexOf(component);
      trackAddOnsDeselected(components[idx].id);
      components.splice(idx, 1);
      return components;
    } else if (components.some(byAddonType(addOn.type)) && SINGLE_ADDON_TYPES.includes(addOn.type)) {
      // If I can only have one type
      const component = components.find(byAddonType(addOn.type));
      const idx = components.indexOf(component);
      trackAddOnsDeselected(components[idx].id);
      components.splice(idx, 1, { id: addOn.id });
    } else {
      components.push({ id: addOn.id });
    }

    trackAddOnsSelected(addOn.id);
  }
  return components;
};

export const getProductsFromSelectedAddons = props => {
  const queryComponents = get(props, 'productCustomisation.components', []);
  const components = [];
  const products = [];

  queryComponents.forEach(component => {
    if (!PRODUCT_ADDON_TYPES.find(type => component.id.includes(type))) {
      products.push(component);
      return;
    }
    components.push(component);
  });

  if (!isEmpty(products)) {
    const items = products.map(product => {
      const variant = findVariantById(product.id, props.products);
      const customisations = {
        locale: get(variant, 'options.locale', 'en-GB'),
        format_identifier: get(variant, 'formatId', null)
      };
      return {
        productId: variant.id.split(':')[0],
        customisations: omitBy(customisations, isNil)
      };
    });
    return [
      {
        productId: skus[props.productKey],
        customisations: {
          ...props.productCustomisation,
          components
        },
      },
      ...items,
    ];
  }

  return null;
};



// WEBPACK FOOTER //
// ./src/client/js/view/components/AddOns/helpers.js